module.exports = __webpack_public_path__ + "static/media/fertilizer1.f0a487b4.jpg";